module.exports = __webpack_public_path__ + "static/pic05-1b2bfead3701041e70f026926bb86591.jpg";